import { createReducer } from '@reduxjs/toolkit';
import {
  setJobApplicantFeatureAction,
  setJobApplicantLinkErrorAction,
  setJobApplicantLinkSuccessAction,
  setJobApplicantLinksAction,
  setJobApplicantLinksLoadingAction,
} from 'store/actions/job-applicant-link-actions';
import { IJobApplicantLinkState } from 'types/employee/IJobApplicantLink';

const initialState: IJobApplicantLinkState = {
  links: [],
  loading: false,
  error: null,
  rejectedLocationIds: [],
  success: false,
  featureCompanyId: null,
  featureEnabled: false,
};

const jobApplicantLinkReducer = createReducer(initialState, builder =>
  builder
    .addCase(setJobApplicantLinksAction, (state, action) => ({ ...state, links: action.payload }))
    .addCase(setJobApplicantLinksLoadingAction, (state, action) => ({ ...state, loading: action.payload }))
    .addCase(setJobApplicantLinkSuccessAction, (state, action) => ({ ...state, success: action.payload }))
    .addCase(setJobApplicantLinkErrorAction, (state, action) => ({
      ...state,
      error: action.payload.error,
      rejectedLocationIds: action.payload.rejectedLocationIds ?? [],
    }))
    .addCase(setJobApplicantFeatureAction, (state, action) => ({
      ...state,
      featureCompanyId: action.payload.companyId,
      featureEnabled: action.payload.enabled,
    })),
);

export default jobApplicantLinkReducer;
